import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import MeetingPage from './components/MeetingPage';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';

// الثيم الرئيسي مع تطبيق خط الكايرو
const theme = createTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: '#80b49e',
      light: '#94c4ac',
      dark: '#5a8f7a',
    },
    secondary: {
      main: '#ff6b6b',
    },
    background: {
      default: '#f8fbfa',
    },
  },
  typography: {
    fontFamily: '"Cairo", "Arial", sans-serif',
    h1: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 700,
    },
    h3: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 500,
    },
    subtitle1: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 400,
    },
    subtitle2: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 400,
    },
    body1: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 400,
    },
    button: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 500,
    },
    caption: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 400,
    },
    overline: {
      fontFamily: '"Cairo", sans-serif',
      fontWeight: 400,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: '"Cairo", sans-serif',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: '"Cairo", sans-serif !important',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: '"Cairo", sans-serif !important',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputBase-input': {
            fontFamily: '"Cairo", sans-serif !important',
          },
          '& .MuiInputLabel-root': {
            fontFamily: '"Cairo", sans-serif !important',
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          fontFamily: '"Cairo", sans-serif !important',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: '"Cairo", sans-serif !important',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontFamily: '"Cairo", sans-serif !important',
        },
        secondary: {
          fontFamily: '"Cairo", sans-serif !important',
        },
      },
    },
  },
});

// مكون GlobalStyles لتطبيق الخط على كل العناصر
const GlobalStyles = () => (
  <style>
    {`
      * {
        font-family: 'Cairo', sans-serif !important;
      }
      
      body {
        font-family: 'Cairo', sans-serif !important;
        margin: 0;
        padding: 0;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }
      
      /* للتأكد من أن كل النصوص تستخدم الخط */
      .MuiTypography-root,
      .MuiButton-root,
      .MuiInputBase-input,
      .MuiInputLabel-root,
      .MuiSelect-select,
      .MuiMenuItem-root,
      .MuiListItemText-primary,
      .MuiListItemText-secondary,
      .MuiChip-label,
      .MuiAlert-message,
      .MuiSnackbarContent-message {
        font-family: 'Cairo', sans-serif !important;
      }
    `}
  </style>
);

// مكون علشان يمرر الـ meetingId لصفحة الاجتماع
const MeetingPageWrapper = () => {
  const { meetingId } = useParams();
  return <MeetingPage meetingId={meetingId} />;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles />
      <Router>
        <Routes>
          {/* Route علشان meeting ID */}
          <Route path="/meeting/:meetingId" element={<MeetingPageWrapper />} />
          {/* Route افتراضي */}
          <Route path="/" element={<MeetingPage />} />
          <Route path="*" element={<MeetingPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;